<template>
  <v-container class="pa-0 fill-height" fluid>
    <!-- Snackbar para operaciones -->
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackbarColor">{{
      snackbarText
    }}</v-snackbar>

    <!-- Layout de carga -->
    <LoadingLayout v-if="isLoading">
      <CircularLoading>
        Registrando mesa
      </CircularLoading>
    </LoadingLayout>

    <!-- Contenido principal -->
    <v-container v-else fluid style="height: 100%;">
      <!-- Fila para el texto y los botones -->
      <DeltiaCard class="pb-5" v-if="!isLoading">
        <!-- Columna para el título -->
        <v-col cols="12" md="9" class="mb-5 mb-md-0">
          <p class="text-h5 font-weight-bold mb-0 pb-0">Nueva mesa</p>
        </v-col>
        <!-- Columna para guardar el producto -->
        <v-col cols="12" md="3">
          <PrimaryButton @click="createProduct">Guardar</PrimaryButton>
        </v-col>
      </DeltiaCard>
      <!-- Fila para los datos principales y la imagen -->
      <DeltiaCard class="pb-6" v-if="!isLoading">
        <v-row no-gutters>
          <!-- Datos principales -->
          <v-col cols="12" md="9">
            <!-- Nombre y descripción -->
            <v-row>
              <!-- Nombre -->
              <v-col class="pt-0 pb-0" cols="12">
                <!-- Ayuda -->
                <p class="mb-1 font-weight-medium text--disabled">Nombre</p>
                <!-- Campo de texto -->
                <TextField
                  class="margin-no"
                  placeholder="Agregar nombre"
                  v-model="name"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </DeltiaCard>
    </v-container>
  </v-container>
</template>

<script>
// importar componentes
import LoadingLayout from "@/layouts/LoadingLayout";
import CircularLoading from "@/components/Loading/Circular";
import DeltiaCard from "@/components/DeltiaCard";
import TextField from "@/components/TextField";
import PrimaryButton from "@/components/PrimaryButton";

// Importar dependencias
import { mapGetters } from "vuex";

// Importar servicios
import TablesServices from "@/services/TablesServices";

export default {
  components: {
    LoadingLayout,
    CircularLoading,
    TextField,
    DeltiaCard,
    PrimaryButton
  },
  data() {
    return {
      name: "",
      timeout: 4000,
      snackbar: false,
      isLoading: false,
      snackbarText: "",
      snackbarColor: ""
    };
  },
  methods: {
    async createProduct() {
      // Ponemos la pantalla de carga
      this.isLoading = true;

      // Verificar que los campos estén completos
      if (!this.areFieldsComplete) {
        // Emitir evento con el error
        this.isLoading = false;
        this.showError("Rellena los campos necesarios, por favor");
        return;
      }

      // Realizamos la petición
      try {
        const tableId = await TablesServices.createTable({
          name: this.name
        });

        // Enviar evento a mixpanel
        this.$mixpanel.track("new-table", {
          distinct_id: this.getProfile.business_id,
          name: this.name
        });

        this.isLoading = false;

        // regresamos a la página de mesas
        this.$router.push({ name: "tables" });
      } catch (err) {
        // Desactivamos el dialogo
        this.isLoading = false;
        // Mostrar error
        this.showError(err.message);
      }
    },
    showError(errorMessage) {
      this.snackbarText = errorMessage;
      this.snackbarColor = "error";
      this.snackbar = true;
    }
  },
  computed: {
    ...mapGetters(["getProfile"]),
    areFieldsComplete() {
      // Revisar que los campos necesarios estén rellenos
      if (!!this.name) {
        return true;
      }

      return false;
    }
  }
};
</script>

<style></style>
